import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  PrintSiteRef,
  CustomerType,
  CheckLayout,
} from '../../core/models/reference.model';
import { ReferenceActions } from './reference.actions';
import * as ReferenceSelectors from './reference.selectors';

@Injectable({ providedIn: 'root' })
export class ReferenceFacade {
  private readonly store = inject(Store);

  // Print Sites
  readonly printSites$: Observable<PrintSiteRef[]> = this.store.select(
    ReferenceSelectors.selectPrintSites
  );
  readonly activePrintSites$: Observable<PrintSiteRef[]> = this.store.select(
    ReferenceSelectors.selectActivePrintSites
  );
  readonly printSitesLoading$: Observable<boolean> = this.store.select(
    ReferenceSelectors.selectPrintSitesLoading
  );
  readonly printSitesLoaded$: Observable<boolean> = this.store.select(
    ReferenceSelectors.selectPrintSitesLoaded
  );

  // Customer Types
  readonly customerTypes$: Observable<CustomerType[]> = this.store.select(
    ReferenceSelectors.selectCustomerTypes
  );
  readonly activeCustomerTypes$: Observable<CustomerType[]> = this.store.select(
    ReferenceSelectors.selectActiveCustomerTypes
  );
  readonly customerTypesLoading$: Observable<boolean> = this.store.select(
    ReferenceSelectors.selectCustomerTypesLoading
  );
  readonly customerTypesLoaded$: Observable<boolean> = this.store.select(
    ReferenceSelectors.selectCustomerTypesLoaded
  );

  // Check Layouts
  readonly checkLayouts$: Observable<CheckLayout[]> = this.store.select(
    ReferenceSelectors.selectCheckLayouts
  );
  readonly activeCheckLayouts$: Observable<CheckLayout[]> = this.store.select(
    ReferenceSelectors.selectActiveCheckLayouts
  );
  readonly checkLayoutsLoading$: Observable<boolean> = this.store.select(
    ReferenceSelectors.selectCheckLayoutsLoading
  );
  readonly checkLayoutsLoaded$: Observable<boolean> = this.store.select(
    ReferenceSelectors.selectCheckLayoutsLoaded
  );

  // Combined
  readonly allDataLoaded$: Observable<boolean> = this.store.select(
    ReferenceSelectors.selectAllReferenceDataLoaded
  );
  readonly anyDataLoading$: Observable<boolean> = this.store.select(
    ReferenceSelectors.selectAnyReferenceDataLoading
  );
  readonly error$: Observable<string | null> = this.store.select(
    ReferenceSelectors.selectReferenceError
  );

  // Actions
  loadAllReferenceData(): void {
    this.store.dispatch(ReferenceActions.loadAllReferenceData());
  }

  loadPrintSites(): void {
    this.store.dispatch(ReferenceActions.loadPrintSites());
  }

  loadCustomerTypes(): void {
    this.store.dispatch(ReferenceActions.loadCustomerTypes());
  }

  loadCheckLayouts(): void {
    this.store.dispatch(ReferenceActions.loadCheckLayouts());
  }
}
